import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/coin.png';
import _imports_1 from '../../assets/images/video_detail_like_red.png';
import _imports_2 from '../../assets/images/mine/video_detail_like.png';
import _imports_3 from '../../assets/images/mine/video_detail_more.png';
import _imports_4 from '../../assets/images/mine/video_detail_send.png';

const _withScopeId = n => (_pushScopeId("data-v-19434653"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "videoDetails"
};
const _hoisted_2 = {
  class: "head_title head_top_20"
};
const _hoisted_3 = {
  class: "video_box"
};
const _hoisted_4 = {
  key: 0,
  class: "loading"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  class: "player-container-id",
  id: "player-container-id-lb",
  width: "100%",
  height: "100%",
  preload: "auto",
  playsinline: "",
  "webkit-playsinline": ""
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "cont webkit-overflow-scrolling-touch"
};
const _hoisted_8 = {
  class: "tab_cont"
};
const _hoisted_9 = {
  class: "user_top"
};
const _hoisted_10 = {
  class: "img_box"
};
const _hoisted_11 = {
  class: "text_box"
};
const _hoisted_12 = {
  class: "text_ellipsis"
};
const _hoisted_13 = {
  class: "text_ellipsis"
};
const _hoisted_14 = {
  class: "btn_box"
};
const _hoisted_15 = {
  class: "info-title"
};
const _hoisted_16 = {
  key: 0,
  class: "info-tagList"
};
const _hoisted_17 = {
  class: "coin tag_item"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_19 = ["onClick"];

const _hoisted_20 = /*#__PURE__*/_createTextVNode("无法播放? ");

const _hoisted_21 = {
  class: "info-time"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dian"
}, "·", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dian"
}, "·", -1));

const _hoisted_24 = {
  class: "info-btn-box"
};
const _hoisted_25 = {
  key: 0,
  src: _imports_1
};
const _hoisted_26 = {
  key: 1,
  src: _imports_2,
  alt: ""
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求续集", -1));

const _hoisted_29 = [_hoisted_27, _hoisted_28];
const _hoisted_30 = {
  class: "advertse"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "info-recommend"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info-recommend-title"
}, "为你推荐", -1));

const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "info-videoCover"
};
const _hoisted_36 = {
  class: "info-videoCover-img"
};
const _hoisted_37 = {
  class: "info-videoInfo"
};
const _hoisted_38 = {
  key: 0,
  class: "bottom"
};

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "优质评论优先展示", -1));

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_42 = [_hoisted_39, _hoisted_40, _hoisted_41];
const _hoisted_43 = {
  class: "video-detail-input"
};
const _hoisted_44 = {
  class: "input-box"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));

const _hoisted_46 = {
  class: "details_page"
};
const _hoisted_47 = {
  class: "details_page"
};
const _hoisted_48 = {
  class: "dialog_content"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "无法播放原因", -1));

const _hoisted_50 = {
  class: "details_page_app"
};
const _hoisted_51 = {
  class: "head_title"
};

const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "详情", -1));

const _hoisted_53 = {
  class: "cont_body_app"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_header = _resolveComponent("my-header");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_my_image = _resolveComponent("my-image");

  const _component_search_popup = _resolveComponent("search-popup");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_ask_video = _resolveComponent("ask-video");

  const _component_van_radio = _resolveComponent("van-radio");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_radio_group = _resolveComponent("van-radio-group");

  const _component_ask_for_video_details = _resolveComponent("ask-for-video-details");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_my_header), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_3, [$setup.showStart || $setup.showEnd ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$setup.videoImgs.start && $setup.showStart ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "a",
    onClick: _cache[1] || (_cache[1] = $event => $setup.toBannerDetails($setup.videoImgs.start))
  }, [(_openBlock(), _createBlock(_component_my_image, {
    url: $setup.videoImgs.start.url,
    key: $setup.videoImgs.start.url
  }, null, 8, ["url"])), _createVNode(_component_van_icon, {
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $setup.showStart = false, ["stop"])),
    name: "close"
  })])) : _createCommentVNode("", true), $setup.videoImgs.end && $setup.showEnd ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "b",
    onClick: _cache[3] || (_cache[3] = $event => $setup.toBannerDetails($setup.videoImgs.end))
  }, [(_openBlock(), _createBlock(_component_my_image, {
    url: $setup.videoImgs.end.url,
    key: $setup.videoImgs.end.url
  }, null, 8, ["url"])), _createVNode(_component_van_icon, {
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $setup.showEnd = false, ["stop"])),
    name: "close"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
    id: "videoBox",
    class: _normalizeClass($setup.isFullscreen ? 'fullscreen' : '')
  }, _hoisted_6, 2)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(), _createBlock(_component_my_image, {
    key: $setup.detailsData.id,
    url: $setup.detailsData.top_image || '/123.png'
  }, null, 8, ["url"]))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString($setup.detailsData.nickname), 1), _createElementVNode("p", _hoisted_13, _toDisplayString($setup.detailsData.user_label) + "- " + _toDisplayString($setup.detailsData.fans || 0) + "粉丝 ·" + _toDisplayString($setup.detailsData.video_num) + "视频 ", 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", {
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.focusSave && $setup.focusSave(...args)),
    style: _normalizeStyle({
      background: $setup.detailsData.isFocus ? '#5B5B5B' : '#276AD3'
    })
  }, _toDisplayString($setup.detailsData.isFocus ? "已关注" : "关注"), 5)])]), _createElementVNode("p", _hoisted_15, _toDisplayString($setup.detailsData.title), 1), $setup.detailsData.label ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, [_hoisted_18, _createTextVNode(" " + _toDisplayString($setup.detailsData.money), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsData.label, item => {
    return _openBlock(), _createElementBlock("span", {
      onClick: $event => $setup.labelSearch(item),
      key: item,
      class: "tag_item"
    }, "#" + _toDisplayString(item), 9, _hoisted_19);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("p", {
    class: "no-play",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.noPlay && $setup.noPlay(...args))
  }, [_createVNode(_component_van_icon, {
    name: "warning-o"
  }), _hoisted_20]), _createElementVNode("p", _hoisted_21, [_createTextVNode(_toDisplayString($setup.detailsData.count) + "次播放", 1), _hoisted_22, _createTextVNode(_toDisplayString($setup.detailsData.like_num) + "赞", 1), _hoisted_23, _createTextVNode(_toDisplayString($setup.detailsData.day || "") + "发布 ", 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
    class: "info-btn-item",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.likeVideo && $setup.likeVideo(...args))
  }, [$setup.detailsData.isLike ? (_openBlock(), _createElementBlock("img", _hoisted_25)) : (_openBlock(), _createElementBlock("img", _hoisted_26)), _createElementVNode("span", {
    style: _normalizeStyle({
      color: $setup.detailsData.isLike ? '#FC5B17' : '#e6e6e6'
    })
  }, "喜欢", 4)]), _createElementVNode("div", {
    class: "info-btn-item",
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.askVideo && $setup.askVideo(...args))
  }, _hoisted_29)]), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bannerList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "img_banner",
      onClick: $event => $setup.toBannerDetails(item),
      key: index
    }, [_createVNode(_component_my_image, {
      url: item.url
    }, null, 8, ["url"])], 8, _hoisted_31);
  }), 128))]), _createElementVNode("div", _hoisted_32, [_hoisted_33, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tjList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "info-videoItem",
      onClick: $event => $setup.videoPlay(item)
    }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", null, [_createVNode(_component_my_image, {
      url: item.image
    }, null, 8, ["url"])])]), _createElementVNode("span", null, _toDisplayString($setup.getMyDate(item.created, 2)), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.context), 1), _createElementVNode("span", null, _toDisplayString(item.count) + "次播放", 1)])])], 8, _hoisted_34);
  }), 128))])])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", {
    class: "input_box",
    onClick: _cache[8] || (_cache[8] = (...args) => $setup.inputSend && $setup.inputSend(...args))
  }, _hoisted_42)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _withDirectives(_createElementVNode("input", {
    id: "inputId",
    type: "text",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $setup.message = $event),
    placeholder: "优质评论优先展示"
  }, null, 512), [[_vModelText, $setup.message]])]), _createElementVNode("span", {
    class: "input-sub",
    onClick: _cache[10] || (_cache[10] = (...args) => $setup.send && $setup.send(...args))
  }, "确定")], 512), [[_vShow, $setup.showInput]]), _createVNode(_component_van_popup, {
    show: $setup.showSearchPopup,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => $setup.showSearchPopup = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [(_openBlock(), _createBlock(_component_search_popup, {
      searchText: $setup.searchText,
      key: $setup.key,
      type: 'details',
      label_name: $setup.label_name,
      onClose: $setup.close1
    }, null, 8, ["searchText", "label_name", "onClose"]))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showAskVideo,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => $setup.showAskVideo = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [(_openBlock(), _createBlock(_component_ask_video, {
      detailsData: $setup.detailsData,
      key: $setup.detailsData.id,
      onClose: $setup.close2
    }, null, 8, ["detailsData", "onClose"]))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDialog,
    "onUpdate:show": _cache[16] || (_cache[16] = $event => $setup.showDialog = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_hoisted_49, _createVNode(_component_van_radio_group, {
      modelValue: $setup.checked,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.checked = $event),
      "checked-color": "#FF551D"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
          return _openBlock(), _createBlock(_component_van_cell, {
            clickable: "",
            key: item,
            title: item.label,
            onClick: $event => $setup.toggle(item)
          }, {
            "right-icon": _withCtx(() => [_createVNode(_component_van_radio, {
              name: item.value
            }, null, 8, ["name"])]),
            _: 2
          }, 1032, ["title", "onClick"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"]), $setup.checked === 3 ? _withDirectives((_openBlock(), _createElementBlock("input", {
      key: 0,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.fkMessage = $event),
      type: "text",
      "max-length": "8",
      placeholder: "请输入反馈内容"
    }, null, 512)), [[_vModelText, $setup.fkMessage]]) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "btns",
      onClick: _cache[15] || (_cache[15] = (...args) => $setup.noPlayOk && $setup.noPlayOk(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showAskVideoDetails,
    "onUpdate:show": _cache[17] || (_cache[17] = $event => $setup.showAskVideoDetails = $event),
    class: "popup_coentent",
    overlay: false,
    teleport: "#app",
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: _withModifiers($setup.close3, ["stop"])
    }, null, 8, ["onClick"]), _hoisted_52]), _createElementVNode("div", _hoisted_53, [(_openBlock(), _createBlock(_component_ask_for_video_details, {
      key: $setup.ask_video_id,
      id: $setup.ask_video_id
    }, null, 8, ["id"]))])])]),
    _: 1
  }, 8, ["show"])]);
}